// Classifies a Mattermost REST v4 HTTP response status into a retry policy.
// Spec §7.4: "Retry theo lớp lỗi: 429/backoff, network/5xx; 401/403 báo cần
// sửa kết nối, không retry dày." — 429 and 5xx are transient (retryable with
// backoff); 401/403 are auth/permission failures that retrying blindly won't
// fix (fail-soft: surface immediately, no tight retry loop).
export type MattermostRetryClass = "retryable" | "auth_failure" | "not_retryable";

export interface RetryClassification {
  retryClass: MattermostRetryClass;
  retryable: boolean;
  reason: string;
}

// 429 = rate limited; 5xx = server-side transient. Both retryable with
// backoff (caller decides the backoff schedule — this module only classifies).
export function classifyMattermostResponseStatus(status: number): RetryClassification {
  if (status === 429) {
    return { retryClass: "retryable", retryable: true, reason: "rate_limited_429" };
  }
  if (status >= 500 && status <= 599) {
    return { retryClass: "retryable", retryable: true, reason: `server_error_${status}` };
  }
  if (status === 401 || status === 403) {
    return { retryClass: "auth_failure", retryable: false, reason: `auth_failure_${status}` };
  }
  if (status >= 200 && status < 300) {
    return { retryClass: "not_retryable", retryable: false, reason: "success" };
  }
  return { retryClass: "not_retryable", retryable: false, reason: `client_error_${status}` };
}
